import OrderInfo from './components/OrderInfo'
import useHook, { orderdetailTabKey } from './hooks'
import RadioTabs from '../../components/RadioTabs'
import CustomTable from '../../components/CustomTable'
import TableAntd from '../../components/TableAntd'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Row,
  Space,
  Steps,
  Select,
  Spin,
  Form,
  Input,
  Popover,
  Timeline,
  Modal,
} from 'antd'
import CustomModal from '../../components/ModalUser'
import moment from 'moment'
import { getShipQty, GetLocalStorage } from '../../tools/util'
import _ from 'lodash'
import { DetailedProductDTOList } from '../../api/orderManage'
import { CarOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import PreviewModal, {
  DefaultWaterMarkOption,
} from '../../components/previewModal'

export type OrderProgressType = '待发货' | '已完成'
// 发货相关状态
export const deliveryStateDict = {
  待收货: {
    name: '待收货',
    color: 'rgb(40, 129, 255)',
    numstr: '1',
  },
  已签收: {
    name: '已签收',
    color: 'green',
    numstr: '2',
  },
  已撤销: {
    name: '已撤销',
    color: '#101010',
    numstr: '7',
  },
}
export const returnStateDict = {
  退货中: {
    name: '退货中',
    color: 'rgb(40, 129, 255)',
    numstr: '5',
  },
  已退货: {
    name: '已退货',
    color: 'rgb(3, 134, 64)',
    numstr: '6',
  },
  已撤销: {
    name: '已撤销',
    color: 'gray',
    numstr: '7',
  },
}
export const stateColorDict = {}
export const stateTextDict: any = {
  5: '退货中',
  6: '已退货',
}
export default function OrderDetail() {
  const {
    hooksState,
    handleCheckedChange,
    handleDeliveryClick,
    handleTableChangeCheck,
    confirmOrder,
    changeExpress,
    handleDeliveryInfoSave,
    handleChangeDeliveryInfoCancel,
    formModal,
    onExpressSearch,
    onExpressSelect,
    confirmGoods,
    exportOrder,
    getCurrentProgress,
    exportSelectOrderDetail,
    showPreviewModal,
    cancelPreviewModal,
    rejectOrder,
    handleRejectOk,
    handleRejectCancel,
    changeRejectReason,
    downLoadModalCancel,
    downLoadModalOk,
    handleDownLoadTableCheck,
    getDetailInfo,
  } = useHook()

  const {
    checkedRadioKey,
    currentRadioDict,
    detailInfo,
    isTableLoading,
    productList,
    loading,
    deliveryList,
    returnDetailList,
    cancelDetailList,
    submitBtnLoading,
    expressSelectList,
    isChangeDeliveryInfoModalVisible,
    expressSearchValue,
    progressTime,
    logisticsInfoList,
    rejectModalOpen,
    rejectReason,
    rejectLoading,
    showRejectTip,
    downLoadModal,
    downLoadModalLoading,
    customerOrderCodeList,
    downLoadSelectedRowKeys,
    isPreviewModalVisible,
    previewFileUrl,
    waterMarkOption,
  } = hooksState

  const DownloadColumn = [
    {
      dataIndex: 'customerOrderCode',
      key: 'customerOrderCode',
      title: '客户订单号',
      width: 150,
    },
  ]
  // 下拉搜索关键字高亮
  const LightHeightOption = (props: any) => {
    const { filterTxt, text } = props
    const heightLightTxt = (txt: string, heightTxt: string) => {
      if (heightTxt === '') {
        return txt
      }
      // 前面filterOption 不区分大小写，这里用i
      const regexp = new RegExp(heightTxt, 'gi')
      return txt.replace(regexp, '<span style="color:red">$&</span>')
    }
    return (
      <div
        ref={(nodeElement) => {
          if (nodeElement) {
            nodeElement.innerHTML = heightLightTxt(text, filterTxt)
          }
        }}
      />
    )
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const orderProgressRender = (text: OrderProgressType, record: any) => {
    const progressObj: {
      [x in OrderProgressType]: {
        text: OrderProgressType
        [key: string]: any
      }
    } = {
      待发货: { text: '待发货', color: '#F5222D' },
      已完成: { text: '已完成', color: '#389E0D' },
    }
    return (
      <Space>
        <span style={{ color: progressObj[text]?.color }}>
          {progressObj[text]?.text}
          {/* {text} */}
        </span>
        {record.returnQty > 0 ? (
          <span className="cancel-tag">有退货</span>
        ) : null}
      </Space>
    )
  }
  const defaultProductImg = `${GetLocalStorage(
    'BASEURL',
  )}ui-common-imgs/default_pic.svg`
  const thumbnailRender = (text?: string | null) => {
    const imgSrc = text?.trim() ? text : defaultProductImg
    return (
      <img
        src={imgSrc}
        alt=""
        onClick={() => text && showPreviewModal(text, DefaultWaterMarkOption)}
        onError={(event) => {
          if (event.currentTarget.src !== defaultProductImg) {
            event.currentTarget.src = defaultProductImg
          }
        }}
        style={{
          width: '40px',
          height: '40px',
          objectFit: 'contain',
          cursor: text ? 'pointer' : 'default',
        }}
      />
    )
  }
  const currentProgress = getCurrentProgress()
  const formConfig: {
    [x in orderdetailTabKey]: {
      listColumn: any[]
    }
  } = {
    商品明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          width: 80,
          render: orderNoRender,
        },
        {
          key: 'progress',
          dataIndex: 'progress',
          title: '进度',
          filters: [
            {
              text: '待发货',
              value: '待发货',
            },
            {
              text: '已完成',
              value: '已完成',
            },
          ] as {
            text: any
            value: OrderProgressType
          }[],
          onFilter: (value: string, record: any) => {
            return value === record?.progress
          },
          className: 'orderDerail-progress',
          render: orderProgressRender,
          width: 150,
        },
        {
          key: 'mainPicture',
          dataIndex: 'mainPicture',
          title: '商品图',
          width: 100,
          render: thumbnailRender,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 200,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 150,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '型号',
          width: 150,
        },
        {
          key: 'description',
          dataIndex: 'description',
          title: '描述',
          width: 250,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 150,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 150,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 150,
        },
        {
          key: 'warehouseName',
          dataIndex: 'warehouseName',
          title: '收货仓库',
          width: 150,
        },
        {
          key: 'deliverTime',
          dataIndex: 'deliverTime',
          title: '发货时间',
          width: 200,
          render: (text: any) =>
            text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
          key: 'waitQty',
          dataIndex: 'waitQty',
          title: '可发数量',
          width: 100,
        },
        {
          key: 'shipQty',
          dataIndex: 'shipQty',
          title: '已发数量',
          width: 100,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退货数量',
          width: 100,
        },
        {
          key: 'cancelQty',
          dataIndex: 'cancelQty',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'stockInputQty',
          dataIndex: 'stockInputQty',
          title: '采购入库数量',
          width: 150,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退库数量',
          width: 100,
        },
        {
          key: 'settleQty',
          dataIndex: 'settleQty',
          title: '实际结算数量',
          width: 120,
        },
      ],
    },
    发货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '型号',
          width: 150,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'shipQty',
          dataIndex: 'shipQty',
          title: '已发数量',
          width: 100,
        },
        {
          key: 'cancelInboundQuantity',
          dataIndex: 'cancelInboundQuantity',
          title: '取消入库数量',
          width: 100,
        },
      ],
    },
    退货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
          width: 150,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退货数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'openRedInvoice',
          dataIndex: 'openRedInvoice',
          title: '是否开红票',
          render: (text: boolean) => {
            return text ? '是' : '否'
          },
          width: 100,
        },
      ],
    },
    取消明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
          width: 150,
        },
        {
          key: 'cancelQty',
          dataIndex: 'cancelQty',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
      ],
    },
  }

  // 渲染物流信息数据
  const getLogisticsInfo = (index: number) => {
    if (logisticsInfoList[index]) {
      return (
        <Timeline
          style={{
            minWidth: '400px',
            maxHeight: '300px',
            overflow: 'auto',
            padding: '4px',
          }}
        >
          {logisticsInfoList[index].map((item: any, index: number) => (
            <Timeline.Item key={index}>
              {item.AcceptTime} {item.accept_address}
            </Timeline.Item>
          ))}
        </Timeline>
      )
    }
  }

  return (
    <div className={styles['inner-content']}>
      <div style={{ padding: '0 80px' }}>
        <Steps
          progressDot
          current={currentProgress}
          className={styles['order-step']}
        >
          {progressTime.map((item) => (
            <Steps.Step
              title={item.title}
              key={item.timeKey}
              description={
                <div>
                  <p>{item.description}</p>
                  {item.time && (
                    <p>{moment(item.time).format('YYYY-MM-DD HH:mm:ss')}</p>
                  )}
                </div>
              }
            />
          ))}
        </Steps>
      </div>
      <OrderInfo
        infoObj={{ ...detailInfo }}
        confirmOrder={confirmOrder}
        rejectOrder={rejectOrder}
        productList={productList}
        cancelTime={progressTime[0]?.time}
        onRefreshDetail={getDetailInfo}
      ></OrderInfo>
      <div className={styles['tab-container']}>
        <RadioTabs
          radioItemDict={currentRadioDict}
          defaultKey={checkedRadioKey}
          onChange={handleCheckedChange}
        ></RadioTabs>
      </div>
      <div style={{ padding: '0 20px' }}>
        <Spin spinning={loading}>
          {(() => {
            switch (checkedRadioKey) {
              case '商品明细':
                return (
                  <>
                    {detailInfo?.scpShipStatusName !== '挂起'
                      ? !detailInfo?.refuseState && (
                          <div className={styles.promptInfo}>
                            <span>可发数量为0，该条物料发货进度视为完成</span>
                            <div>
                              <Button
                                style={{
                                  marginRight: '8px',
                                }}
                                className={styles['submit-button']}
                                onClick={exportSelectOrderDetail}
                              >
                                导出配货单
                              </Button>
                              <Button
                                style={{
                                  marginRight: '8px',
                                }}
                                className={styles['submit-button']}
                                onClick={exportOrder}
                              >
                                导出全部
                              </Button>
                              {/* <span style={{ margin: '0 5px', color: '#111' }}>
                                 发货进度{detailInfo?.detailedProductDTOList.shipQty}
                                 发货进度
                                {detailInfo?.shipProgress}
                              </span> */}
                              {productList.some(
                                (item: DetailedProductDTOList) => {
                                  return (
                                    ['待发货'] as OrderProgressType[]
                                  ).includes(item?.progress ?? '')
                                },
                              ) ? (
                                <Button
                                  type="primary"
                                  className={styles['submit-button']}
                                  onClick={handleDeliveryClick}
                                >
                                  发货
                                </Button>
                              ) : null}
                            </div>
                          </div>
                        )
                      : ''}
                    <TableAntd
                      selfAdaptScroll
                      dataSource={productList}
                      loading={isTableLoading}
                      listColumn={formConfig['商品明细'].listColumn}
                      onChangeCheck={handleTableChangeCheck}
                    ></TableAntd>
                  </>
                )
              case '发货明细':
                if (deliveryList.length === 0)
                  return (
                    <div className={styles['empty-container']}>
                      暂无发货数据，赶紧去发货吧
                    </div>
                  )
                else {
                  return deliveryList.map((item: any, index: number) => {
                    const deliveryState = _.find(
                      deliveryStateDict,
                      (o) => o.numstr === item?.state,
                    )
                    return (
                      <div
                        className={styles['delivery-info-container']}
                        key={index}
                      >
                        <div className={styles['info-container']}>
                          <Row justify="space-between">
                            <Space>
                              <div className={styles['title']}>
                                发货单{index + 1}
                              </div>
                              <span>时间：{item?.deliveryTime}</span>
                            </Space>
                            <Space>
                              {/* <Button onClick={() => exportSendOrder(item.id)}>
                                导出配货单
                              </Button> */}
                              {deliveryStateDict['待收货'].numstr ===
                                item?.state &&
                              (item?.warehousing ?? true) !== true ? (
                                <Button onClick={() => changeExpress(item)}>
                                  变更物流信息
                                </Button>
                              ) : null}
                            </Space>
                          </Row>
                          <Row justify="space-between">
                            <Col span={6}>
                              物流公司：{item?.logisticsCompany}
                            </Col>
                            <Col span={6}>
                              {item?.logisticsCompany !== '厂家配送'
                                ? '快递单号'
                                : '送货人手机号'}
                              ：{item?.trackNum}
                              {item?.logisticsCompany !== '厂家配送' &&
                                item?.trackNum && (
                                  <Popover
                                    content={getLogisticsInfo(index)}
                                    title="物流信息"
                                  >
                                    <span className={styles['logistice-info']}>
                                      <CarOutlined
                                        className={styles['logistice-icon']}
                                      />
                                      物流信息
                                    </span>
                                  </Popover>
                                )}
                            </Col>
                            <Col span={6}>
                              签收状态：
                              <span
                                style={{
                                  color: deliveryState?.color ?? 'black',
                                }}
                              >
                                {item?.stateToName}
                              </span>
                            </Col>
                          </Row>
                        </div>
                        <CustomTable
                          dataSource={item?.shipProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['发货明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
              case '退货明细':
                if (returnDetailList.length === 0) {
                  return (
                    <div className={styles['empty-container']}>暂无数据</div>
                  )
                } else {
                  return returnDetailList.map((item: any, index: number) => {
                    const returnState = _.find(
                      returnStateDict,
                      (o) => o.numstr === item.state,
                    )
                    return (
                      <div key={index}>
                        <div className={styles['return-info-container']}>
                          <div className={styles['info-container']}>
                            <Row justify="space-between">
                              <Space>
                                <div className={styles['title']}>
                                  退货单{index + 1}
                                </div>
                                <span>时间：{item?.returnTime}</span>
                              </Space>
                              <Space>
                                {item.state ===
                                returnStateDict['退货中'].numstr ? (
                                  <Button onClick={() => confirmGoods(item.id)}>
                                    确认收货
                                  </Button>
                                ) : null}
                              </Space>
                            </Row>
                            <Row>
                              <Col span={6}>
                                退货单编号：{item?.returnNumber}
                              </Col>
                              <Col span={6}>退款金额：{item?.returnPrice}</Col>
                              <Col span={6}>
                                状态：
                                <span
                                  style={{
                                    color: returnState?.color ?? 'black',
                                  }}
                                >
                                  {returnState?.name}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={6}>
                                物流公司：{item?.logisticsCompany}
                              </Col>
                              <Col span={6}>快递单号：{item?.trackNum}</Col>
                              {/* <Col span={6}>备注：{item?.remark}</Col> */}
                            </Row>
                          </div>
                        </div>
                        <CustomTable
                          dataSource={item?.returnProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['退货明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
              case '取消明细':
                if (cancelDetailList.length === 0) {
                  return (
                    <div className={styles['empty-container']}>暂无数据</div>
                  )
                } else {
                  return cancelDetailList.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <CustomTable
                          dataSource={item?.cancelProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['取消明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
            }
          })()}
        </Spin>
      </div>
      <CustomModal
        title="变更物流信息"
        footer={
          <Row justify="center">
            <Button onClick={handleDeliveryInfoSave} loading={submitBtnLoading}>
              保存
            </Button>
          </Row>
        }
        modalCancel={handleChangeDeliveryInfoCancel}
        visible={isChangeDeliveryInfoModalVisible}
      >
        <Form form={formModal} className={styles.formStyle}>
          <Form.Item
            className={styles['form-item']}
            name="expressCompany"
            label="物流公司"
            rules={[
              {
                required: true,
                message: '物流公司必选',
              },
            ]}
          >
            <Select
              placeholder="请选择"
              allowClear
              showSearch
              onSearch={onExpressSearch}
              onSelect={onExpressSelect}
              filterOption={(input, option: any) =>
                (option.children &&
                  option.children.props &&
                  option.children.props.text &&
                  option.children.props.text
                    .toLowerCase()
                    .indexOf(input.toLowerCase())) >= 0
              }
              getPopupContainer={() => document.body}
              onChange={() => formModal.validateFields(['expressNo'])}
            >
              {expressSelectList?.map((item: any) => {
                return (
                  <Select.Option
                    key={item.expressCode}
                    value={item.expressCode}
                  >
                    <LightHeightOption
                      text={item.expressCompany}
                      filterTxt={expressSearchValue}
                    ></LightHeightOption>
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          {formModal.getFieldValue('expressCompany') !== 'XHZYWL' ? (
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="物流单号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: true,
                  whitespace: getFieldValue('expressCompany') !== '厂家配送',
                  validator: function (rule: any, value: string) {
                    if (!value) {
                      return Promise.reject(new Error('物流单号未填写'))
                    }
                    if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                      return Promise.reject(
                        new Error('只支持输入字母、数字、反斜杠"/"'),
                      )
                    }
                    if (value.length > 60) {
                      return Promise.reject(
                        new Error(
                          '物流单号最多输入60字，否则无法正常销售发货，多个物流单号请分开入库',
                        ),
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Input placeholder="请输入" maxLength={60}></Input>
            </Form.Item>
          ) : (
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="送货人手机号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: true,
                  message: '请输入正确的手机号',
                  pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                  whitespace: getFieldValue('expressCompany') === '厂家配送',
                }),
              ]}
            >
              <Input placeholder="请输入"></Input>
            </Form.Item>
          )}
        </Form>
      </CustomModal>
      <Modal
        title="拒绝接单"
        open={rejectModalOpen}
        bodyStyle={{
          height: 200,
        }}
        keyboard={false}
        maskClosable={false}
        closable={false}
        footer={[
          <Button
            key="closeRejectModal"
            disabled={rejectLoading}
            onClick={handleRejectCancel}
          >
            取消
          </Button>,
          <Button
            key="confirmRejectModal"
            type="primary"
            onClick={handleRejectOk}
            loading={rejectLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ marginTop: -10, marginBottom: 15, width: 80 }}>
            <span style={{ color: 'red' }}>*</span>拒绝理由：
          </div>
          <div
            style={{
              marginTop: '-6px',
            }}
          >
            <TextArea
              placeholder="请输入"
              value={rejectReason}
              maxLength={140}
              readOnly={rejectLoading}
              onChange={(e) => changeRejectReason(e.target.value.trim())}
              style={{
                resize: 'none',
                width: 360,
                height: 130,
                border: `${'1px solid'}${showRejectTip ? ' red' : ' #f2f2f2'}`,
                borderRadius: 3,
              }}
            />
            {showRejectTip && <div style={{ color: 'red' }}>请输入</div>}
          </div>
        </div>
      </Modal>
      <Modal
        title="客户单号选择"
        open={downLoadModal}
        keyboard={false}
        maskClosable={false}
        onCancel={downLoadModalCancel}
        footer={[
          <Button
            key="confirmDownLoadModal"
            type="primary"
            onClick={downLoadModalOk}
            loading={downLoadModalLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div>
          <div
            style={{ color: 'orange', fontSize: '16px', marginTop: '-20px' }}
          >
            请选择需要导出的客户订单
          </div>
          <TableAntd
            scrollCustom={{ y: 350 }}
            scrollStyle={{
              height: 'auto',
            }}
            X={150}
            dataSource={customerOrderCodeList}
            listColumn={DownloadColumn}
            onChangeCheck={handleDownLoadTableCheck}
            showSize
            rowKey="customerOrderCode"
            loading={false}
          ></TableAntd>
          <div style={{ marginTop: '15px' }}>
            已选中{downLoadSelectedRowKeys?.length}条
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
        waterMarkOption={waterMarkOption}
      />
    </div>
  )
}
import OrderInfo from './components/OrderInfo'
import useHook, { orderdetailTabKey } from './hooks'
import RadioTabs from '../../components/RadioTabs'
import CustomTable from '../../components/CustomTable'
import TableAntd from '../../components/TableAntd'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Row,
  Space,
  Steps,
  Select,
  Spin,
  Form,
  Input,
  Popover,
  Timeline,
  Modal,
} from 'antd'
import CustomModal from '../../components/ModalUser'
import moment from 'moment'
import { getShipQty, GetLocalStorage } from '../../tools/util'
import _ from 'lodash'
import { DetailedProductDTOList } from '../../api/orderManage'
import { CarOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import PreviewModal, {
  DefaultWaterMarkOption,
} from '../../components/previewModal'

export type OrderProgressType = '待发货' | '已完成'
// 发货相关状态
export const deliveryStateDict = {
  待收货: {
    name: '待收货',
    color: 'rgb(40, 129, 255)',
    numstr: '1',
  },
  已签收: {
    name: '已签收',
    color: 'green',
    numstr: '2',
  },
  已撤销: {
    name: '已撤销',
    color: '#101010',
    numstr: '7',
  },
}
export const returnStateDict = {
  退货中: {
    name: '退货中',
    color: 'rgb(40, 129, 255)',
    numstr: '5',
  },
  已退货: {
    name: '已退货',
    color: 'rgb(3, 134, 64)',
    numstr: '6',
  },
  已撤销: {
    name: '已撤销',
    color: 'gray',
    numstr: '7',
  },
}
export const stateColorDict = {}
export const stateTextDict: any = {
  5: '退货中',
  6: '已退货',
}
export default function OrderDetail() {
  const {
    hooksState,
    handleCheckedChange,
    handleDeliveryClick,
    handleTableChangeCheck,
    confirmOrder,
    changeExpress,
    handleDeliveryInfoSave,
    handleChangeDeliveryInfoCancel,
    formModal,
    onExpressSearch,
    onExpressSelect,
    confirmGoods,
    exportOrder,
    getCurrentProgress,
    exportSelectOrderDetail,
    showPreviewModal,
    cancelPreviewModal,
    rejectOrder,
    handleRejectOk,
    handleRejectCancel,
    changeRejectReason,
    downLoadModalCancel,
    downLoadModalOk,
    handleDownLoadTableCheck,
    getDetailInfo,
  } = useHook()

  const {
    checkedRadioKey,
    currentRadioDict,
    detailInfo,
    isTableLoading,
    productList,
    loading,
    deliveryList,
    returnDetailList,
    cancelDetailList,
    submitBtnLoading,
    expressSelectList,
    isChangeDeliveryInfoModalVisible,
    expressSearchValue,
    progressTime,
    logisticsInfoList,
    rejectModalOpen,
    rejectReason,
    rejectLoading,
    showRejectTip,
    downLoadModal,
    downLoadModalLoading,
    customerOrderCodeList,
    downLoadSelectedRowKeys,
    isPreviewModalVisible,
    previewFileUrl,
    waterMarkOption,
  } = hooksState

  const DownloadColumn = [
    {
      dataIndex: 'customerOrderCode',
      key: 'customerOrderCode',
      title: '客户订单号',
      width: 150,
    },
  ]
  // 下拉搜索关键字高亮
  const LightHeightOption = (props: any) => {
    const { filterTxt, text } = props
    const heightLightTxt = (txt: string, heightTxt: string) => {
      if (heightTxt === '') {
        return txt
      }
      // 前面filterOption 不区分大小写，这里用i
      const regexp = new RegExp(heightTxt, 'gi')
      return txt.replace(regexp, '<span style="color:red">$&</span>')
    }
    return (
      <div
        ref={(nodeElement) => {
          if (nodeElement) {
            nodeElement.innerHTML = heightLightTxt(text, filterTxt)
          }
        }}
      />
    )
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const orderProgressRender = (text: OrderProgressType, record: any) => {
    const progressObj: {
      [x in OrderProgressType]: {
        text: OrderProgressType
        [key: string]: any
      }
    } = {
      待发货: { text: '待发货', color: '#F5222D' },
      已完成: { text: '已完成', color: '#389E0D' },
    }
    return (
      <Space>
        <span style={{ color: progressObj[text]?.color }}>
          {progressObj[text]?.text}
          {/* {text} */}
        </span>
        {record.returnQty > 0 ? (
          <span className="cancel-tag">有退货</span>
        ) : null}
      </Space>
    )
  }
  const defaultProductImg = `${GetLocalStorage(
    'BASEURL',
  )}ui-common-imgs/default_pic.svg`
  const thumbnailRender = (text?: string | null) => {
    const imgSrc = text?.trim() ? text : defaultProductImg
    return (
      <img
        src={imgSrc}
        alt=""
        onClick={() => text && showPreviewModal(text, DefaultWaterMarkOption)}
        onError={(event) => {
          if (event.currentTarget.src !== defaultProductImg) {
            event.currentTarget.src = defaultProductImg
          }
        }}
        style={{
          width: '40px',
          height: '40px',
          objectFit: 'contain',
          cursor: text ? 'pointer' : 'default',
        }}
      />
    )
  }
  const currentProgress = getCurrentProgress()
  const formConfig: {
    [x in orderdetailTabKey]: {
      listColumn: any[]
    }
  } = {
    商品明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          width: 80,
          render: orderNoRender,
        },
        {
          key: 'progress',
          dataIndex: 'progress',
          title: '进度',
          filters: [
            {
              text: '待发货',
              value: '待发货',
            },
            {
              text: '已完成',
              value: '已完成',
            },
          ] as {
            text: any
            value: OrderProgressType
          }[],
          onFilter: (value: string, record: any) => {
            return value === record?.progress
          },
          className: 'orderDerail-progress',
          render: orderProgressRender,
          width: 150,
        },
        {
          key: 'mainPicture',
          dataIndex: 'mainPicture',
          title: '商品图',
          width: 100,
          render: thumbnailRender,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 200,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 150,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '型号',
          width: 150,
        },
        {
          key: 'description',
          dataIndex: 'description',
          title: '描述',
          width: 250,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 150,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 150,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 150,
        },
        {
          key: 'warehouseName',
          dataIndex: 'warehouseName',
          title: '收货仓库',
          width: 150,
        },
        {
          key: 'deliverTime',
          dataIndex: 'deliverTime',
          title: '发货时间',
          width: 200,
          render: (text: any) =>
            text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
          key: 'waitQty',
          dataIndex: 'waitQty',
          title: '可发数量',
          width: 100,
        },
        {
          key: 'shipQty',
          dataIndex: 'shipQty',
          title: '已发数量',
          width: 100,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退货数量',
          width: 100,
        },
        {
          key: 'cancelQty',
          dataIndex: 'cancelQty',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'stockInputQty',
          dataIndex: 'stockInputQty',
          title: '采购入库数量',
          width: 150,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退库数量',
          width: 100,
        },
        {
          key: 'settleQty',
          dataIndex: 'settleQty',
          title: '实际结算数量',
          width: 120,
        },
      ],
    },
    发货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '型号',
          width: 150,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'shipQty',
          dataIndex: 'shipQty',
          title: '已发数量',
          width: 100,
        },
        {
          key: 'cancelInboundQuantity',
          dataIndex: 'cancelInboundQuantity',
          title: '取消入库数量',
          width: 100,
        },
      ],
    },
    退货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
          width: 150,
        },
        {
          key: 'returnQty',
          dataIndex: 'returnQty',
          title: '退货数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'openRedInvoice',
          dataIndex: 'openRedInvoice',
          title: '是否开红票',
          render: (text: boolean) => {
            return text ? '是' : '否'
          },
          width: 100,
        },
      ],
    },
    取消明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
          width: 150,
        },
        {
          key: 'cancelQty',
          dataIndex: 'cancelQty',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
      ],
    },
  }

  // 渲染物流信息数据
  const getLogisticsInfo = (index: number) => {
    if (logisticsInfoList[index]) {
      return (
        <Timeline
          style={{
            minWidth: '400px',
            maxHeight: '300px',
            overflow: 'auto',
            padding: '4px',
          }}
        >
          {logisticsInfoList[index].map((item: any, index: number) => (
            <Timeline.Item key={index}>
              {item.AcceptTime} {item.accept_address}
            </Timeline.Item>
          ))}
        </Timeline>
      )
    }
  }

  return (
    <div className={styles['inner-content']}>
      <div style={{ padding: '0 80px' }}>
        <Steps
          progressDot
          current={currentProgress}
          className={styles['order-step']}
        >
          {progressTime.map((item) => (
            <Steps.Step
              title={item.title}
              key={item.timeKey}
              description={
                <div>
                  <p>{item.description}</p>
                  {item.time && (
                    <p>{moment(item.time).format('YYYY-MM-DD HH:mm:ss')}</p>
                  )}
                </div>
              }
            />
          ))}
        </Steps>
      </div>
      <OrderInfo
        infoObj={{ ...detailInfo }}
        confirmOrder={confirmOrder}
        rejectOrder={rejectOrder}
        productList={productList}
        cancelTime={progressTime[0]?.time}
        onRefreshDetail={getDetailInfo}
      ></OrderInfo>
      <div className={styles['tab-container']}>
        <RadioTabs
          radioItemDict={currentRadioDict}
          defaultKey={checkedRadioKey}
          onChange={handleCheckedChange}
        ></RadioTabs>
      </div>
      <div style={{ padding: '0 20px' }}>
        <Spin spinning={loading}>
          {(() => {
            switch (checkedRadioKey) {
              case '商品明细':
                return (
                  <>
                    {detailInfo?.scpShipStatusName !== '挂起'
                      ? !detailInfo?.refuseState && (
                          <div className={styles.promptInfo}>
                            <span>可发数量为0，该条物料发货进度视为完成</span>
                            <div>
                              <Button
                                style={{
                                  marginRight: '8px',
                                }}
                                className={styles['submit-button']}
                                onClick={exportSelectOrderDetail}
                              >
                                导出配货单
                              </Button>
                              <Button
                                style={{
                                  marginRight: '8px',
                                }}
                                className={styles['submit-button']}
                                onClick={exportOrder}
                              >
                                导出全部
                              </Button>
                              {/* <span style={{ margin: '0 5px', color: '#111' }}>
                                 发货进度{detailInfo?.detailedProductDTOList.shipQty}
                                 发货进度
                                {detailInfo?.shipProgress}
                              </span> */}
                              {productList.some(
                                (item: DetailedProductDTOList) => {
                                  return (
                                    ['待发货'] as OrderProgressType[]
                                  ).includes(item?.progress ?? '')
                                },
                              ) ? (
                                <Button
                                  type="primary"
                                  className={styles['submit-button']}
                                  onClick={handleDeliveryClick}
                                >
                                  发货
                                </Button>
                              ) : null}
                            </div>
                          </div>
                        )
                      : ''}
                    <TableAntd
                      selfAdaptScroll
                      dataSource={productList}
                      loading={isTableLoading}
                      listColumn={formConfig['商品明细'].listColumn}
                      onChangeCheck={handleTableChangeCheck}
                    ></TableAntd>
                  </>
                )
              case '发货明细':
                if (deliveryList.length === 0)
                  return (
                    <div className={styles['empty-container']}>
                      暂无发货数据，赶紧去发货吧
                    </div>
                  )
                else {
                  return deliveryList.map((item: any, index: number) => {
                    const deliveryState = _.find(
                      deliveryStateDict,
                      (o) => o.numstr === item?.state,
                    )
                    return (
                      <div
                        className={styles['delivery-info-container']}
                        key={index}
                      >
                        <div className={styles['info-container']}>
                          <Row justify="space-between">
                            <Space>
                              <div className={styles['title']}>
                                发货单{index + 1}
                              </div>
                              <span>时间：{item?.deliveryTime}</span>
                            </Space>
                            <Space>
                              {/* <Button onClick={() => exportSendOrder(item.id)}>
                                导出配货单
                              </Button> */}
                              {deliveryStateDict['待收货'].numstr ===
                                item?.state &&
                              (item?.warehousing ?? true) !== true ? (
                                <Button onClick={() => changeExpress(item)}>
                                  变更物流信息
                                </Button>
                              ) : null}
                            </Space>
                          </Row>
                          <Row justify="space-between">
                            <Col span={6}>
                              物流公司：{item?.logisticsCompany}
                            </Col>
                            <Col span={6}>
                              {item?.logisticsCompany !== '厂家配送'
                                ? '快递单号'
                                : '送货人手机号'}
                              ：{item?.trackNum}
                              {item?.logisticsCompany !== '厂家配送' &&
                                item?.trackNum && (
                                  <Popover
                                    content={getLogisticsInfo(index)}
                                    title="物流信息"
                                  >
                                    <span className={styles['logistice-info']}>
                                      <CarOutlined
                                        className={styles['logistice-icon']}
                                      />
                                      物流信息
                                    </span>
                                  </Popover>
                                )}
                            </Col>
                            <Col span={6}>
                              签收状态：
                              <span
                                style={{
                                  color: deliveryState?.color ?? 'black',
                                }}
                              >
                                {item?.stateToName}
                              </span>
                            </Col>
                          </Row>
                        </div>
                        <CustomTable
                          dataSource={item?.shipProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['发货明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
              case '退货明细':
                if (returnDetailList.length === 0) {
                  return (
                    <div className={styles['empty-container']}>暂无数据</div>
                  )
                } else {
                  return returnDetailList.map((item: any, index: number) => {
                    const returnState = _.find(
                      returnStateDict,
                      (o) => o.numstr === item.state,
                    )
                    return (
                      <div key={index}>
                        <div className={styles['return-info-container']}>
                          <div className={styles['info-container']}>
                            <Row justify="space-between">
                              <Space>
                                <div className={styles['title']}>
                                  退货单{index + 1}
                                </div>
                                <span>时间：{item?.returnTime}</span>
                              </Space>
                              <Space>
                                {item.state ===
                                returnStateDict['退货中'].numstr ? (
                                  <Button onClick={() => confirmGoods(item.id)}>
                                    确认收货
                                  </Button>
                                ) : null}
                              </Space>
                            </Row>
                            <Row>
                              <Col span={6}>
                                退货单编号：{item?.returnNumber}
                              </Col>
                              <Col span={6}>退款金额：{item?.returnPrice}</Col>
                              <Col span={6}>
                                状态：
                                <span
                                  style={{
                                    color: returnState?.color ?? 'black',
                                  }}
                                >
                                  {returnState?.name}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={6}>
                                物流公司：{item?.logisticsCompany}
                              </Col>
                              <Col span={6}>快递单号：{item?.trackNum}</Col>
                              {/* <Col span={6}>备注：{item?.remark}</Col> */}
                            </Row>
                          </div>
                        </div>
                        <CustomTable
                          dataSource={item?.returnProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['退货明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
              case '取消明细':
                if (cancelDetailList.length === 0) {
                  return (
                    <div className={styles['empty-container']}>暂无数据</div>
                  )
                } else {
                  return cancelDetailList.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        <CustomTable
                          dataSource={item?.cancelProductDTOList}
                          isLoading={isTableLoading}
                          columns={formConfig['取消明细'].listColumn}
                        ></CustomTable>
                      </div>
                    )
                  })
                }
            }
          })()}
        </Spin>
      </div>
      <CustomModal
        title="变更物流信息"
        footer={
          <Row justify="center">
            <Button onClick={handleDeliveryInfoSave} loading={submitBtnLoading}>
              保存
            </Button>
          </Row>
        }
        modalCancel={handleChangeDeliveryInfoCancel}
        visible={isChangeDeliveryInfoModalVisible}
      >
        <Form form={formModal} className={styles.formStyle}>
          <Form.Item
            className={styles['form-item']}
            name="expressCompany"
            label="物流公司"
            rules={[
              {
                required: true,
                message: '物流公司必选',
              },
            ]}
          >
            <Select
              placeholder="请选择"
              allowClear
              showSearch
              onSearch={onExpressSearch}
              onSelect={onExpressSelect}
              filterOption={(input, option: any) =>
                (option.children &&
                  option.children.props &&
                  option.children.props.text &&
                  option.children.props.text
                    .toLowerCase()
                    .indexOf(input.toLowerCase())) >= 0
              }
              getPopupContainer={() => document.body}
              onChange={() => formModal.validateFields(['expressNo'])}
            >
              {expressSelectList?.map((item: any) => {
                return (
                  <Select.Option
                    key={item.expressCode}
                    value={item.expressCode}
                  >
                    <LightHeightOption
                      text={item.expressCompany}
                      filterTxt={expressSearchValue}
                    ></LightHeightOption>
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          {formModal.getFieldValue('expressCompany') !== 'XHZYWL' ? (
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="物流单号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: true,
                  whitespace: getFieldValue('expressCompany') !== '厂家配送',
                  validator: function (rule: any, value: string) {
                    if (!value) {
                      return Promise.reject(new Error('物流单号未填写'))
                    }
                    if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                      return Promise.reject(
                        new Error('只支持输入字母、数字、反斜杠"/"'),
                      )
                    }
                    if (value.length > 60) {
                      return Promise.reject(
                        new Error(
                          '物流单号最多输入60字，否则无法正常销售发货，多个物流单号请分开入库',
                        ),
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Input placeholder="请输入" maxLength={60}></Input>
            </Form.Item>
          ) : (
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="送货人手机号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: true,
                  message: '请输入正确的手机号',
                  pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                  whitespace: getFieldValue('expressCompany') === '厂家配送',
                }),
              ]}
            >
              <Input placeholder="请输入"></Input>
            </Form.Item>
          )}
        </Form>
      </CustomModal>
      <Modal
        title="拒绝接单"
        open={rejectModalOpen}
        bodyStyle={{
          height: 200,
        }}
        keyboard={false}
        maskClosable={false}
        closable={false}
        footer={[
          <Button
            key="closeRejectModal"
            disabled={rejectLoading}
            onClick={handleRejectCancel}
          >
            取消
          </Button>,
          <Button
            key="confirmRejectModal"
            type="primary"
            onClick={handleRejectOk}
            loading={rejectLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ marginTop: -10, marginBottom: 15, width: 80 }}>
            <span style={{ color: 'red' }}>*</span>拒绝理由：
          </div>
          <div
            style={{
              marginTop: '-6px',
            }}
          >
            <TextArea
              placeholder="请输入"
              value={rejectReason}
              maxLength={140}
              readOnly={rejectLoading}
              onChange={(e) => changeRejectReason(e.target.value.trim())}
              style={{
                resize: 'none',
                width: 360,
                height: 130,
                border: `${'1px solid'}${showRejectTip ? ' red' : ' #f2f2f2'}`,
                borderRadius: 3,
              }}
            />
            {showRejectTip && <div style={{ color: 'red' }}>请输入</div>}
          </div>
        </div>
      </Modal>
      <Modal
        title="客户单号选择"
        open={downLoadModal}
        keyboard={false}
        maskClosable={false}
        onCancel={downLoadModalCancel}
        footer={[
          <Button
            key="confirmDownLoadModal"
            type="primary"
            onClick={downLoadModalOk}
            loading={downLoadModalLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div>
          <div
            style={{ color: 'orange', fontSize: '16px', marginTop: '-20px' }}
          >
            请选择需要导出的客户订单
          </div>
          <TableAntd
            scrollCustom={{ y: 350 }}
            scrollStyle={{
              height: 'auto',
            }}
            X={150}
            dataSource={customerOrderCodeList}
            listColumn={DownloadColumn}
            onChangeCheck={handleDownLoadTableCheck}
            showSize
            rowKey="customerOrderCode"
            loading={false}
          ></TableAntd>
          <div style={{ marginTop: '15px' }}>
            已选中{downLoadSelectedRowKeys?.length}条
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
        waterMarkOption={waterMarkOption}
      />
    </div>
  )
}
